import React from 'react';
var h = React.createElement;
import S from 'pull-stream';
import _ from 'pull-stream-util';
import many from 'pull-many';
import ViewStream from '@invintus/react-pull-stream';
import combineLatest from 'pull-combine-latest';
import join from 'pull-flat-merge';
import Notify from 'pull-notify';
import Request from '../../ott/lib/requests';
import OttListView from '../../ott/view/list/index';
import ChannelsModel from '../../ott/model/ott-channels';
import AssetsModel from '../../ott/model/assets';
import ErrorPage from '../../landing/error/Error';
import { hasPermission } from '../../lib/components/form/RestrictedComponent';

function OttListRoute (api, socket, opts, match) {
    if (!hasPermission("manage_ott.read")) {
        return function NotFound (props) {
            return h(ErrorPage, { code: 401 }, []);
        };
    }

    var viewStream = ViewStream(OttListView);
    var channelsStore = ChannelsModel.store();
    var state = Notify();

    S(
        combineLatest({
            assets: S(
                Request('get', api.assets.get.bind(api.assets, {
                    advancedDetails: true
                })),
                AssetsModel.store()
            ),

            channels: S(
                many([
                    _.sample.toArray(
                        state.listen(),
                        viewStream.source
                    ),
                    _.sample.toArray(
                        state.listen(),
                        Request('get', api.ott.getChannels)
                    )
                ]),
                S.map(ChannelsModel.effects(api)),
                join(),
                channelsStore(),
                S.through(state) // broadcast the state changes
            )
        }),

        viewStream.sink
    );

    return viewStream.view;
}

export default OttListRoute;
